import "./dashboard-ui.css";

export default function EmptyState({ icon = "mdi-inbox-outline", title = "Aucune donnée", subtitle }) {
  return (
    <div className="empty-state">
      <i className={`mdi ${icon}`}></i>
      <div className="empty-state-title">{title}</div>
      {subtitle && <div className="small">{subtitle}</div>}
    </div>
  );
}
